import { useTheme } from '@/contexts/ThemeContext';

interface AnalyticsIconProps {
  className?: string;
  color?: string;
}

export default function StaticChartIcon({ className, color }: AnalyticsIconProps) {
  const { theme } = useTheme();
  const fill =
    color ?? (theme === 'dark' ? 'rgb(var(--color-primary-350))' : 'rgb(var(--color-primary))');
  return (
    <svg
      width="52"
      height="36"
      viewBox="0 0 52 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.32913 19.1938C2.38582 19.1938 0 21.7128 0 24.8202V30.3735C0 33.481 2.38582 35.9999 5.32913 35.9999C8.27244 35.9999 10.6583 33.481 10.6583 30.3735V24.8202C10.6583 21.7128 8.27244 19.1938 5.32913 19.1938Z"
        fill={fill}
      />
      <path
        d="M18.9873 5.6499C16.044 5.6499 13.6582 8.1688 13.6582 11.2763V30.3734C13.6582 33.4809 16.044 35.9998 18.9873 35.9998C21.9306 35.9998 24.3165 33.4809 24.3165 30.3734V11.2763C24.3165 8.1688 21.9306 5.6499 18.9873 5.6499Z"
        fill={fill}
      />
      <path
        d="M32.6455 13.9277C29.7022 13.9277 27.3164 16.4466 27.3164 19.5541V30.3735C27.3164 33.4809 29.7022 35.9998 32.6455 35.9998C35.5888 35.9998 37.9747 33.4809 37.9747 30.3735V19.5541C37.9747 16.4466 35.5888 13.9277 32.6455 13.9277Z"
        fill={fill}
      />
      <path
        d="M46.3037 0C43.3604 0 40.9746 2.5189 40.9746 5.62638V30.3735C40.9746 33.481 43.3604 35.9999 46.3037 35.9999C49.247 35.9999 51.6329 33.481 51.6329 30.3735V5.62638C51.6329 2.5189 49.247 0 46.3037 0Z"
        fill={fill}
      />
    </svg>
  );
}
